import { createContext, useContext, type ReactNode } from "react";

interface ResponsiveModalFooterContextValue {
  setFooter: (footer: ReactNode | null) => void;
}

export const ResponsiveModalFooterContext =
  createContext<ResponsiveModalFooterContextValue | null>(null);

export function useResponsiveModalFooter() {
  return useContext(ResponsiveModalFooterContext);
}
